var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -705.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/Home",
    transform: "translate(1970.000000, 705.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1224636,0 L2,11 L2,25.053 C2,28.89 5.12181831,32 8.9733993,32 L12.9885997,32 L12.9885997,23 C12.9885997,21.896 13.8870008,21 14.9961999,21 L17.0038001,21 C18.1119954,21 19.0114003,21.896 19.0114003,23 L19.0114003,32 L23.0266007,32 C26.8781817,32 30,28.89 30,25.053 L30,11 L16.1224636,0 Z",
    id: 55
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsHome);
export default __webpack_public_path__ + "static/media/buildings-home.94b9b617.svg";
export { ForwardRef as ReactComponent };